<template>
  <div>
    <slot name="button" :open="openModal">
      <v-btn color="white" depressed rounded light large @click="openModal">
        <v-icon small class="mr-2">mdi-flash</v-icon>
        <b class="text-capitalize font-weight-bold">{{ $t("bulk_edit") }}</b>
      </v-btn>
    </slot>
    <v-dialog
      v-model="open"
      :fullscreen="$vuetify.breakpoint.mobile"
      :hide-overlay="$vuetify.breakpoint.mobile"
      persistent
      scrollable
      :max-width="!$vuetify.breakpoint.mobile ? '75%' : '100%'"
    >
      <v-form v-if="open" v-model="isValid">
        <v-card>
          <v-card-title class="image-bg pb-0 px-4 white--text">
            <div class="d-block full-width">
              <div class="d-flex justify-space-between">
                <span class="text-h5"> {{ $t("bulk_edit") }}</span>
                <v-btn @click="close" icon dark :disabled="saving">
                  <v-icon>mdi-close</v-icon>
                </v-btn>
              </div>
              <v-row>
                <v-col cols="12" sm="6" lg="6">
                  <h4>{{ $t("period") }}</h4>
                  <v-menu
                    v-model="menuPeriod"
                    :close-on-content-click="false"
                    transition="scale-transition"
                  >
                    <template v-slot:activator="{ on }">
                      <v-btn
                        text
                        block
                        rounded
                        outlined
                        dark
                        large
                        style="border-color: rgba(250,250,250,0.2)"
                        v-on="on"
                      >
                        <span class="flex-grow-1 text-left">
                          {{ formatedDatesRange }}
                        </span>
                        <v-icon class="align-self-right">
                          mdi-calendar-month-outline
                        </v-icon>
                      </v-btn>
                    </template>
                    <v-date-picker
                      class="d-block"
                      :min="minDate"
                      color="accent"
                      v-model="datesRange"
                      @input="onDatesRangeInput"
                      range
                      :title-date-format="() => formatedDatesRange"
                      first-day-of-week="1"
                    ></v-date-picker>
                  </v-menu>
                </v-col>
                <v-col>
                  <h4>{{ $t("days") }}</h4>
                  <v-chip-group
                    v-model="daysSelected"
                    active-class="white"
                    multiple
                  >
                    <v-chip
                      outlined
                      class="white--text"
                      v-for="(day, key) of days"
                      :key="key"
                      :value="key"
                      >{{ day }}</v-chip
                    >
                  </v-chip-group>
                </v-col>
              </v-row>

              <v-tabs v-model="tab" background-color="transparent">
                <v-tab
                  v-for="(t, key) of tabs"
                  :key="key"
                  class="white--text"
                  active-class="active-tab-bg"
                >
                  {{ $t(t) }}
                </v-tab>
              </v-tabs>
            </div>
          </v-card-title>
          <v-card-text class="px-4">
            <v-tabs-items v-model="tab">
              <v-tab-item>
                <v-row>
                  <v-col class="px-12">
                    <v-card
                      outlined
                      rounded="lg"
                      class="operation-selector"
                      style="overflow:hidden; margin:auto"
                    >
                      <v-row no-gutters>
                        <v-col
                          v-for="option in operationOptions"
                          :key="option.value"
                          cols="12"
                          sm="4"
                          class="pa-0"
                        >
                          <v-card flat tile @click="setOperation(option.value)">
                            <v-list
                              class="py-0 option-rate"
                              :class="{
                                'info selected': operation === option.value
                              }"
                            >
                              <v-list-item class="px-2">
                                <v-list-item-avatar
                                  size="60"
                                  color="white"
                                  style="margin-right: 8px;"
                                >
                                  <v-img
                                    :src="option.img"
                                    contain
                                    max-height="45"
                                  ></v-img>
                                </v-list-item-avatar>
                                <v-list-item-content>
                                  <v-list-item-title
                                    class="text-body-2 font-weight-bold"
                                  >
                                    {{ $t(option.title) }}
                                  </v-list-item-title>
                                  <v-list-item-subtitle
                                    class="text-body-2 text-wrap"
                                    style="font-size:11px !important;"
                                    >{{ $t(option.subtitle) }}
                                  </v-list-item-subtitle>
                                </v-list-item-content>
                              </v-list-item>
                            </v-list>
                          </v-card>
                        </v-col>
                      </v-row>
                    </v-card>
                  </v-col>
                </v-row>
                <v-row class="px-4">
                  <v-col cols="12" sm="3" class="pb-0">
                    <v-text-field
                      :label="
                        operation === 'absolute'
                          ? $t('new_rate')
                          : $t('modify_rate')
                      "
                      type="number"
                      v-model="priceValue"
                      :rules="priceRules"
                      outlined
                      rounded
                      dense
                    >
                      <template #append>
                        <v-icon v-if="operation === 'relative_percentage'">
                          mdi-percent
                        </v-icon>
                        <v-icon v-else>mdi-currency-eur</v-icon>
                      </template>
                    </v-text-field>
                  </v-col>
                  <v-col cols="12" sm="9" class="pb-0">
                    <v-autocomplete
                      v-model="priceRoomTypes"
                      :items="priceRoomTypeItems"
                      :label="$t('categories')"
                      :hint="derivedHint"
                      persistent-hint
                      multiple
                      chips
                      small-chips
                      deletable-chips
                      outlined
                      rounded
                      dense
                    ></v-autocomplete>
                  </v-col>
                </v-row>
              </v-tab-item>
              <v-tab-item>
                <v-row class="px-4 pt-4">
                  <v-col cols="12" sm="3" class="pb-0">
                    <v-text-field
                      :label="$t('min_nights')"
                      type="number"
                      v-model="mlosValue"
                      :rules="mlosRules"
                      outlined
                      rounded
                      dense
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="9" class="pb-0">
                    <v-autocomplete
                      v-model="mlosRoomTypes"
                      :items="mlosRoomTypeItems"
                      :label="$t('categories')"
                      multiple
                      chips
                      small-chips
                      deletable-chips
                      outlined
                      rounded
                      dense
                    ></v-autocomplete>
                  </v-col>
                </v-row>
              </v-tab-item>
            </v-tabs-items>

            <v-row>
              <v-col>
                <v-progress-linear
                  v-if="loadingCurrent"
                  indeterminate
                  color="secondary"
                ></v-progress-linear>
                <template v-else-if="formIsValid">
                  <v-alert v-if="changes.length === 0" type="warning" dense>
                    {{ $t("rms_bulk_edit_no_changes") }}
                  </v-alert>
                  <template v-else>
                    <v-alert type="info" dense>
                      {{
                        $t("rms_bulk_edit_summary", {
                          changes: changes.length,
                          days: changedDaysCount
                        })
                      }}
                    </v-alert>
                    <v-simple-table dense fixed-header height="260px">
                      <thead>
                        <tr>
                          <th>{{ $t("date") }}</th>
                          <th>{{ $t("category") }}</th>
                          <th class="text-right">{{ $t(tabs[tab]) }}</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr
                          v-for="change in changes"
                          :key="`${change.date}-${change.roomtype}`"
                        >
                          <td>{{ formatDate(change.date) }}</td>
                          <td>{{ roomTypeName(change.roomtype) }}</td>
                          <td class="text-right">
                            <span
                              v-if="change.current !== null"
                              class="text-decoration-line-through grey--text"
                            >
                              {{ formatValue(change.current) }}
                            </span>
                            <v-icon small class="mx-1">
                              mdi-arrow-right-bold
                            </v-icon>
                            <b>{{ formatValue(change.value) }}</b>
                          </td>
                        </tr>
                      </tbody>
                    </v-simple-table>
                  </template>
                </template>
              </v-col>
            </v-row>
          </v-card-text>

          <v-divider></v-divider>
          <v-card-actions class="pa-4">
            <v-btn
              depressed
              rounded
              @click="save"
              color="info"
              class="px-12"
              :loading="saving"
              :disabled="!formIsValid || loadingCurrent || changes.length === 0"
              >{{ $t("apply") }}</v-btn
            >
            <v-btn
              depressed
              rounded
              outlined
              @click="close"
              class="px-12"
              :disabled="saving"
              >{{ $t("cancel") }}</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-form>
    </v-dialog>
  </div>
</template>

<script>
import Vue from "vue";
import { mapGetters, mapState } from "vuex";
import RmsService from "@/services/RmsService";
import pencil from "@/assets/imgs/pencil.png";
import euro from "@/assets/imgs/euro.png";
import percent from "@/assets/imgs/percent.png";
import {
  channelManagerCellOperations,
  getFriendlyDate,
  rateChangeLogSnackbarExtras,
  showError
} from "@/utils";
var numeral = require("numeral");

// Changes per request: keeps each bulk call well below the request timeout
const CHUNK_SIZE = 60;

// 0 = Monday ... 6 = Sunday
const weekdayIndex = date => Vue.moment(date).isoWeekday() - 1;

const enumerateDates = (from, to) => {
  const dates = [];
  const current = Vue.moment(from);
  const last = Vue.moment(to);
  while (current.isSameOrBefore(last, "day")) {
    dates.push(current.format("YYYY-MM-DD"));
    current.add(1, "days");
  }
  return dates;
};

export default {
  name: "a-rms-strategy-bulk-edit",
  data: () => ({
    open: false,
    isValid: false,
    menuPeriod: false,
    datesRange: [],
    daysSelected: [],
    tab: 0,
    operation: "relative_percentage",
    priceValue: undefined,
    mlosValue: undefined,
    // Each tab keeps its own categories: the price only applies to master
    // categories, the minimum stay to any of them
    priceRoomTypes: [],
    mlosRoomTypes: [],
    // { [date]: { [roomtype]: { pvp, mlos } } }
    currentValues: {},
    loadingCurrent: false,
    saving: false,
    operations: channelManagerCellOperations(),
    operationOptions: [
      {
        value: "absolute",
        img: pencil,
        title: "assign_new_price",
        subtitle: "assign_new_price_sub"
      },
      {
        value: "relative_currency",
        img: euro,
        title: "increase_decrease_current_price",
        subtitle: "increase_decrease_current_price_sub"
      },
      {
        value: "relative_percentage",
        img: percent,
        title: "increase_decrease_current_price_percentage",
        subtitle: "increase_decrease_current_price_percentage_sub"
      }
    ]
  }),
  computed: {
    tabs() {
      return ["price", "min_nights"];
    },
    days() {
      return [1, 2, 3, 4, 5, 6, 7].map(isoWeekday =>
        Vue.moment()
          .isoWeekday(isoWeekday)
          .format("dddd")
          .substring(0, 3)
      );
    },
    minDate() {
      return Vue.moment().format("YYYY-MM-DD");
    },
    sortedDatesRange() {
      return [...this.datesRange].sort();
    },
    formatedDatesRange() {
      if (this.datesRange.length > 1) {
        const [from, to] = this.sortedDatesRange.map(d => Vue.moment(d));
        return from.format("MMMM") !== to.format("MMMM")
          ? this.$t("from_to_dates", {
              from: from.format("D MMMM"),
              to: to.format("D MMMM")
            })
          : this.$t("from_day_to_day_of_month", {
              from: from.format("D"),
              to: to.format("D"),
              month: from.format("MMMM")
            });
      }
      return "";
    },
    // Only master categories can be edited, derived ones are recalculated
    // from their reference by the backend (cascade)
    editableRoomTypes() {
      return (this.roomtype_types_mapped || []).filter(
        rt => rt.ref_room_rate_id === null || rt.ref_room_rate_id === undefined
      );
    },
    derivedRoomTypes() {
      return (this.roomtype_types_mapped || []).filter(
        rt => !this.editableRoomTypes.includes(rt)
      );
    },
    priceRoomTypeItems() {
      return this.editableRoomTypes.map(this.roomTypeItem);
    },
    // The minimum stay is not cascaded to derived categories, so every
    // category can be edited on its own
    mlosRoomTypeItems() {
      return (this.roomtype_types_mapped || []).map(this.roomTypeItem);
    },
    selectedRoomTypes() {
      return this.isPriceTab ? this.priceRoomTypes : this.mlosRoomTypes;
    },
    derivedHint() {
      return this.derivedRoomTypes.length > 0
        ? this.$t("rms_bulk_edit_derived_hint", {
            categories: this.derivedRoomTypes.map(rt => rt.name).join(", ")
          })
        : "";
    },
    priceRules() {
      const rules = [v => !!v || this.$t("required_field")];
      if (this.operation === "absolute") {
        rules.push(v => v > 0 || this.$t("must_be_positive"));
      }
      return rules;
    },
    mlosRules() {
      return [
        v => !!v || this.$t("required_field"),
        v =>
          (Number.isInteger(v * 1) && v * 1 > 0) || this.$t("must_be_positive")
      ];
    },
    isPriceTab() {
      return this.tabs[this.tab] === "price";
    },
    formIsValid() {
      if (
        this.datesRange.length !== 2 ||
        this.daysSelected.length === 0 ||
        this.selectedRoomTypes.length === 0
      ) {
        return false;
      }
      if (this.isPriceTab) {
        const value = this.priceValue * 1;
        return (
          this.priceValue !== undefined &&
          this.priceValue !== "" &&
          !isNaN(value) &&
          value !== 0 &&
          (this.operation !== "absolute" || value > 0)
        );
      }
      const mlos = this.mlosValue * 1;
      return Number.isInteger(mlos) && mlos > 0;
    },
    targetDates() {
      if (this.datesRange.length !== 2) return [];
      const [from, to] = this.sortedDatesRange;
      return enumerateDates(
        Vue.moment.max(Vue.moment(from), Vue.moment(this.minDate)),
        to
      ).filter(date => this.daysSelected.includes(weekdayIndex(date)));
    },
    changes() {
      if (!this.formIsValid) return [];
      const changes = [];
      this.targetDates.forEach(date => {
        this.selectedRoomTypes.forEach(roomtype => {
          const current =
            this.currentValues[date] && this.currentValues[date][roomtype];
          if (this.isPriceTab) {
            const currentPvp =
              current && current.pvp ? Number(current.pvp) : null;
            // Relative changes need a current price to be computed from
            if (this.operation !== "absolute" && !currentPvp) return;
            const value = this.operations[this.operation](
              this.priceValue,
              currentPvp
            );
            if (!(value > 0) || value === currentPvp) return;
            changes.push({ date, roomtype, current: currentPvp, value });
          } else {
            const currentMlos =
              current && current.mlos ? Number(current.mlos) : null;
            const value = this.mlosValue * 1;
            if (value === currentMlos) return;
            changes.push({ date, roomtype, current: currentMlos, value });
          }
        });
      });
      return changes;
    },
    changedDaysCount() {
      return new Set(this.changes.map(c => c.date)).size;
    },
    ...mapGetters({
      current_hotel: "current_hotel",
      l: "current_hotel_language"
    }),
    ...mapState({
      roomtype_types_mapped: state => state.roomtype.types_mapped,
      strategy_from: state => state.rms.strategy_from,
      strategy_to: state => state.rms.strategy_to
    })
  },
  methods: {
    openModal() {
      this.resetForm();
      this.open = true;
      this.fetchCurrentValues();
    },
    close() {
      this.open = false;
    },
    resetForm() {
      const today = this.minDate;
      const from =
        this.strategy_from && this.strategy_from > today
          ? this.strategy_from
          : today;
      const to =
        this.strategy_to && this.strategy_to >= from ? this.strategy_to : from;
      this.datesRange = [from, to];
      this.daysSelected = [0, 1, 2, 3, 4, 5, 6];
      this.tab = 0;
      this.operation = "relative_percentage";
      this.priceValue = undefined;
      this.mlosValue = undefined;
      this.currentValues = {};
      const highlighted = this.editableRoomTypes.find(rt => rt.highlighted);
      const first = highlighted || this.editableRoomTypes[0];
      this.priceRoomTypes = first ? [this.roomTypeCode(first)] : [];
      this.mlosRoomTypes = [...this.priceRoomTypes];
    },
    setOperation(value) {
      this.priceValue = undefined;
      this.operation = value;
    },
    onDatesRangeInput(range) {
      if (range.length === 2) {
        const [from, to] = [...range].sort();
        // Preselect only the weekdays that exist in the chosen period
        this.daysSelected = [
          ...new Set(enumerateDates(from, to).map(weekdayIndex))
        ];
        this.menuPeriod = false;
        this.fetchCurrentValues();
      }
    },
    roomTypeCode(roomType) {
      return roomType.pms_room_type_code || roomType.code;
    },
    roomTypeItem(roomType) {
      return { value: this.roomTypeCode(roomType), text: roomType.name };
    },
    roomTypeName(code) {
      const roomType = (this.roomtype_types_mapped || []).find(
        rt => this.roomTypeCode(rt) === code
      );
      return roomType ? roomType.name : code;
    },
    async fetchCurrentValues() {
      if (this.datesRange.length !== 2 || !this.current_hotel) return;
      const [from, to] = this.sortedDatesRange;
      this.loadingCurrent = true;
      try {
        const response = await RmsService.getKpisDaily({
          hotel_id: this.current_hotel.id,
          from_date: from,
          to_date: to,
          kpis: ["pvp", "mlos"],
          spots: ["otb"],
          dimensions: ["roomtype"],
          dimension_kpis: ["pvp", "mlos"]
        });
        const currentValues = {};
        Object.entries(response.data || {}).forEach(([date, spots]) => {
          currentValues[date] =
            (spots && spots.otb && spots.otb.roomtype) || {};
        });
        this.currentValues = currentValues;
      } catch (e) {
        showError(this, "something_went_wrong");
      } finally {
        this.loadingCurrent = false;
      }
    },
    async save() {
      const kpi = this.isPriceTab ? "pvp" : "mlos";
      const payload = this.changes.map(c => ({
        date: c.date,
        roomtype: c.roomtype,
        [kpi]: c.value
      }));
      this.saving = true;
      this.$store.dispatch("setSnackbar", {
        title: this.$t("applying_all_prices"),
        color: "secondary"
      });
      const failedDates = new Set();
      let requestFailed = false;
      for (let i = 0; i < payload.length; i += CHUNK_SIZE) {
        try {
          const response = await this.$store.dispatch(
            "setRoomTypeDayRatesBulk",
            payload.slice(i, i + CHUNK_SIZE)
          );
          Object.entries((response && response.results) || {}).forEach(
            ([date, result]) => {
              if (result.status !== "ok") failedDates.add(date);
            }
          );
        } catch (e) {
          requestFailed = true;
          payload
            .slice(i, i + CHUNK_SIZE)
            .forEach(c => failedDates.add(c.date));
        }
      }
      this.saving = false;
      this.$store.dispatch("setReloadSubscribedModules");

      if (failedDates.size === 0) {
        this.$store.dispatch("setSnackbar", {
          title: this.$t("changes_applied_successfully"),
          color: "accent",
          ...rateChangeLogSnackbarExtras(this)
        });
        this.close();
      } else {
        this.$store.dispatch("setSnackbar", {
          title: requestFailed
            ? this.$t("changes_not_applied")
            : this.$t("rms_bulk_edit_partial_error", {
                dates: [...failedDates]
                  .sort()
                  .map(d => this.formatDate(d))
                  .join(", ")
              }),
          color: "error",
          ...rateChangeLogSnackbarExtras(this)
        });
        this.fetchCurrentValues();
      }
    },
    formatDate(date) {
      return getFriendlyDate(date, true);
    },
    formatValue(value) {
      if (value === null || value === undefined) return "-";
      if (!this.isPriceTab) return value;
      return (
        this.l.money_pre_symbol +
        numeral(value).format(this.l.number0_format + "[.]00") +
        this.l.money_post_symbol
      );
    }
  }
};
</script>

<style lang="scss" scoped>
.active-tab-bg {
  background-color: transparent;
  font-weight: bold;
  color: white;
}
.image-bg {
  background-image: url("/img/header.jpg");
}
*::v-deep .v-tabs-slider {
  background-color: white;
  color: white;
}
.operation-selector {
  max-width: 60%;
}
@media (max-width: 960px) {
  .operation-selector {
    max-width: 100%;
  }
}
.option-rate {
  cursor: pointer;
  div:hover {
    color: black !important;
  }
  &.selected {
    & div:hover * {
      color: black !important;
    }
    ::v-deep .v-list-item__content {
      color: white !important;
    }
    ::v-deep .v-list-item__subtitle {
      color: white !important;
    }
  }
}
</style>
